import type { Rating } from "@atlas/contracts";
import { Badge } from "./ui/Badge";
import { cx } from "../lib/cx";
import { formatNumberFa } from "../lib/format";

function dotTone(rating: number): "rating-dot--accent" | "rating-dot--sage" | "" {
  if (rating >= 8) return "rating-dot--accent";
  if (rating >= 5) return "rating-dot--sage";
  return "";
}

/** Compact rating indicator for list rows: a colored dot plus "امتیاز N". */
export function RatingDot({ rating }: { rating: Rating | undefined }) {
  return (
    <span className="item-row__meta-group">
      <span className={cx("rating-dot", rating !== undefined && dotTone(rating))} aria-hidden="true" />
      <span>امتیاز {rating === undefined ? "—" : formatNumberFa(rating)}</span>
    </span>
  );
}

/** Full "امتیاز شخصی" badge for detail-page headers — never to be confused with an external score. */
export function RatingBadge({ rating }: { rating: Rating | undefined }) {
  return (
    <Badge tone="solid">امتیاز شخصی {rating === undefined ? "—" : `${formatNumberFa(rating)} از ۱۰`}</Badge>
  );
}
